import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, InputRef, Modal, Space, Table, notification } from 'antd';
import { checkAccess, getUserRole, handleLogout, pendingRequest_column, rejectedApiMessage } from '../../utilities/CommonHelper';
import { approveRejectByAdmin, fetchPendingRequestbyAdmin } from '../../store/reducers/userDashboardSlice';
import { ColumnsType, ColumnType, TablePaginationConfig } from 'antd/es/table';
import Link from 'antd/es/typography/Link';
import CustomButton from '../../components/Buttons/Button';
import MultilineTextbox from '../../components/MultilineTextbox/MultilineTextbox';
import { getUserAccessData } from '../../utilities/sessionHelper';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { FilterConfirmProps } from 'antd/es/table/interface';

interface EmployeeRequest {
    id: number;
    type: string;
    employeeName: string;
    employeeEmail: string;
    employeeId: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    role: string;
    accessReason: string;
    reminderEmailCount: number;
    requestStatus: string;
    approvalRejects: any[];
  }
type DataIndex = keyof EmployeeRequest;
const PendingRequestAtAdminTable = (props:any) => {
    const dispatch = useDispatch();
    const userDashboardData = useSelector((state: any) => state.userDashboard);
    const [pendingUserData,setPendingUserData]=React.useState<any>([]);
    const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";
    const writeAccess:boolean=checkAccess(role,"User Management",getUserAccessData()?.roleAccessMap[role],"write");
    const [searchText, setSearchText] = React.useState('');
    const [searchedColumn, setSearchedColumn] = React.useState('');
    const searchInput = React.useRef<InputRef>(null);
    
    const [modalVisible, setModalVisible] = React.useState(false);
    const [selectedRecord, setSelectedRecord] = React.useState<EmployeeRequest | null>(null);
    const [rejectionReason, setRejectionReason] = React.useState(''); 
    const [pageNo, setPageNo] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);   

    useEffect(() => {
      if(props.activeTab==='1'){
        dispatch(fetchPendingRequestbyAdmin({page:pageNo,size:pageSize})).then((res: any) => {
                
            if(res.type !== 'request/fetchPendingRequestbyAdmin/fulfilled'){
              rejectedApiMessage(res.payload);
            }else{
              setTotalCount(res.payload.totalElements);
          }
          });
        }
    }, [dispatch,props.activeTab,pageNo,pageSize]);

    useEffect(() => {
            console.log('pendingUserData',userDashboardData.pendingUserData);
          setPendingUserData(Array.isArray(userDashboardData.pendingUserData)?userDashboardData.pendingUserData:[]);
        },[userDashboardData.pendingUserData]);



 const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  setSelectedKeys([]);
                  handleSearch([], confirm, dataIndex);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex] && record[dataIndex]
            .toString()
            .toLowerCase()
            .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      }); 
      
      const _pendingRequest_column: ColumnsType<EmployeeRequest> =[
      {
            title: 'Request Id',
            dataIndex: 'id',
            key: 'id',
            width:150,
            ...getColumnSearchProps('id'),
        },
        {
          title: 'Request Type',
          dataIndex: 'type',
          key: 'type',
          width:150,
          ...getColumnSearchProps('type'),
        },
        {
          title: 'Employee Name',
          dataIndex: 'employeeName',
          key: 'employeeName',
          width:150,
          
        },
        {
          title: 'Employee Email',
          dataIndex: 'employeeEmail',
          key: 'employeeEmail',
          width:150,
          ...getColumnSearchProps('employeeEmail'),
        },
        {
          title: 'Employee Id',
          dataIndex: 'employeeId',
          key: 'employeeId',
          width:150,
          ...getColumnSearchProps('employeeId'),
        },
        {
          title: 'Business Unit',
          dataIndex: 'businessUnit',
          key: 'businessUnit',
          width:150,
          ...getColumnSearchProps('businessUnit'),
        },
        {
          title: 'Department',
          dataIndex: 'department',
          key: 'department',
          width:150,
          ...getColumnSearchProps('department'),
        },
        {
          title: 'Reporting Manager Name',
          dataIndex: 'reportingManagerName',
          key: 'reportingManagerName',
          width:150,
          ...getColumnSearchProps('reportingManagerName'),
        },
        {
          title: 'Reporting Manager Email',
          dataIndex: 'reportingManagerEmail',
          key: 'reportingManagerEmail',
          width:150,
          ...getColumnSearchProps('reportingManagerEmail'),
        },
        {
          title: 'Role',
          dataIndex: 'role',
          key: 'role',
          width:150,
          ...getColumnSearchProps('role'),
        },
        {
          title: 'Access Reason',
          dataIndex: 'accessReason',
          key: 'accessReason',
          width:150,
          ...getColumnSearchProps('accessReason'),
        },
        {
          title: 'Request Status',
          dataIndex: 'requestStatus',
          key: 'requestStatus',
          width:150,
          ...getColumnSearchProps('requestStatus'),
        },
        {
          title: 'Actions',
          dataIndex: 'Actions',
          key: 'Actions',
          width: 150,
          fixed: 'right',
          render: (text: string, record: any) => (
            <>
              <Link disabled={!writeAccess} onClick={() => handleApprove(record)}>Approve</Link><br/>
              <Link disabled={!writeAccess} onClick={() => handleReject(record)}>Reject</Link>
            </>
          ),
        }]

        const handleApprove = (record: EmployeeRequest) => {
            let values={
              "requestId": record.id,
              "approvalLevel": "Admin",
              "decision": "APPROVED",
              "reason": null
            }
            // Call the approve API with the record data
            console.log('Approving record:', record);
            dispatch(approveRejectByAdmin(values)).then((response:any)=>{
                  
                  
              if(response.type==='user/request/approveRejectByAdmin/fulfilled'){
                console.log('approveRejectByAdmin response',response);
                notification.success({
                  message: 'Success',
                  description: 'Request Processed Successfully',
                });
                dispatch(fetchPendingRequestbyAdmin({page:pageNo,size:pageSize})).then((res: any) => {
                  if(res.type !== 'request/fetchPendingRequestbyAdmin/fulfilled'){
                    rejectedApiMessage(res.payload);
                  }else{
                    setTotalCount(response.payload.totalElements);
                }
                });
              }
              else{
                rejectedApiMessage(response.payload);
              }
              
            })
          };
        
          const handleReject = (record: EmployeeRequest) => {
            setSelectedRecord(record);
            setModalVisible(true);
          };
        
          const handleModalOk = () => {
            let values={
              "requestId": selectedRecord?.id,
              "approvalLevel": "Admin",
              "decision": "REJECTED",
              "reason": rejectionReason.trim()
            }
            // Call the approve API with the record data
            console.log('rejecting record:', selectedRecord);
            dispatch(approveRejectByAdmin(values)).then((response:any)=>{
              if(response.type==='user/request/approveRejectByAdmin/fulfilled'){
                console.log('approveRejectByRM response',response);
                notification.success({
                  message: 'Success',
                  description: 'Request Processed Successfully',
                });
                dispatch(fetchPendingRequestbyAdmin({page:pageNo,size:pageSize})).then((res: any) => {
                  if(res.type !== 'request/fetchPendingRequestbyAdmin/fulfilled'){
                    rejectedApiMessage(res.payload);
                  }else{
                    setTotalCount(response.payload.totalElements);
                }
                });
                console.log('Rejecting record:', selectedRecord, 'with reason:', rejectionReason);
                setModalVisible(false);
                setSelectedRecord(null);
                setRejectionReason('');
              }
              else{
                rejectedApiMessage(response.payload);
              }
            })
            // Call the reject API with the selected record and rejection reason
            
          };
        
          const handleModalCancel = () => {
            setModalVisible(false);
            setSelectedRecord(null);
            setRejectionReason('');
          };

          const handleValidation=()=>{
            if(rejectionReason.trim().length===0){
              return true;
            }
            return false;
          }
          const handleTableChange = (pagination: TablePaginationConfig) => {
            const { current, pageSize } = pagination;
            setPageNo(current ? current - 1 : 0);
            setPageSize(pageSize || 10);
          };

    return (
        <div className='containerr'>
            <Table
                className='table-style'
                dataSource={pendingUserData}
                columns={_pendingRequest_column}
                scroll={{ x: 'max-content',y: 400}}
                loading={userDashboardData?.loading}
                rowKey="id"
                pagination={{
                  current: pageNo + 1,
                  pageSize,
                  total: totalCount,
                }}
                onChange={handleTableChange}
              >
              </Table>
            
                <Modal
                    title="Reject Request"
                    open={modalVisible}
                    onOk={handleModalOk}
                    onCancel={handleModalCancel}
                    footer={()=>{
                    return(
                        <div style={{display:'flex',justifyContent:'flex-end'}}>
                        <CustomButton type='cancel' label='Cancel' onClick={handleModalCancel}></CustomButton>
                        <CustomButton type='submit' label='Reject'disabled={handleValidation()} onClick={handleModalOk}></CustomButton>
                        </div>
                    )
                    
                    }}
                    styles={{
                    content: {
                        borderRadius: '0',
                        borderTop: '4px solid #1677ff',
                        font: 'normal normal normal 14px/20px Nunito Sans'
                    },
                    }}
                >
                    <MultilineTextbox
                    id='reason'
                    label='Reason for Rejection'
                    key='reasonForRejection'
                    placeholder="Enter reason for rejection"
                    value={rejectionReason}
                    width='200px'
                    onChange={(id:string,newvalue:string,oldvalue:string|null) => setRejectionReason(newvalue)}
                    />
                </Modal>
        </div>
    );
};

export default PendingRequestAtAdminTable;